import { inject, onBeforeUnmount, provide } from 'vue'

const UNSAVED_CHANGES_KEY = Symbol('unsaved-changes')

// Provided by a container (e.g. slideoutWithSlots) that should warn before closing
// while any descendant form reports unsaved changes.
export function provideUnsavedChanges() {
    const checks = new Set()

    provide(UNSAVED_CHANGES_KEY, {
        register(check) {
            checks.add(check)

            return () => checks.delete(check)
        },
    })

    return {
        hasUnsavedChanges: () => [...checks].some((check) => check()),
    }
}

// Reports a form's unsaved changes to the nearest container. A no-op outside one.
export function useUnsavedChanges(isDirty) {
    const container = inject(UNSAVED_CHANGES_KEY, null)

    if (!container) {
        return
    }

    const unregister = container.register(isDirty)

    onBeforeUnmount(unregister)
}

// JSON snapshot for dirty checks, treating null/undefined and '' as equal
// so clearing a field that started empty doesn't count as a change.
export function unsavedChangesSnapshot(value) {
    return JSON.stringify(value, (key, fieldValue) => fieldValue ?? '')
}
